import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import Pagination from 'react-js-pagination'
import uuid from 'uuid/v4'
import Select from 'react-select'

class FlowTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      output: false,
      activePage: 1,
      length: props.data.length,
      tableUUID: uuid(),
      items: props.paginatable
    }
  }

  selectedText () {
    var text = ''
    if (typeof window.getSelection !== 'undefined') {
      text = window.getSelection().toString()
    } else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
      text = document.selection.createRange().text
    }
    return text.length > 0
  }

  componentDidMount () {
    this.filter(this.props, this.state.activePage)
  }
  componentWillReceiveProps (props) {
    this.filter(props, this.state.activePage)
  }
  handlePageChange (page) {
    this.setState({ activePage: page })
    this.filter(this.props, page)
  }
  filter (props, page) {
    var output = props.data.slice()
    if (props.filter) {
      output = output.filter(row => {
        if (typeof row[0] === 'object') return row.slice(1).toString().toUpperCase().indexOf(props.filter.toUpperCase()) > -1
        return row.toString().toUpperCase().indexOf(props.filter.toUpperCase()) > -1
      })
    }
    var length = output.length
    if (props.paginatable) {
      output = output.splice((page - 1) * this.state.items, this.state.items)
    }
    this.setState({ output: output, length: length })
  }
  async handleCount (value) {
    await this.setState({ items: value })
    this.filter(this.props, this.state.activePage)
  }
  render () {
    ReactTooltip.rebuild()
    if (this.props.error) {
      return (
        <div className='no-data-in-table-wrapper'>
          <div className='no-data-text-wrapper'>
            <i className='fa fa-exclamation-triangle' />
            <h3 className='text-center no-data-text'>Error fetching data</h3>
          </div>
        </div>
      )
    }

    if (this.props.hideHeaders && !this.props.data.length && !this.props.loading) {
      return (
        <div className='no-data-in-table-wrapper'>
          <div className='no-data-text-wrapper'>
            <i className={'fa ' + (this.props.emptyIcon ? this.props.emptyIcon : 'fa-database')} />
            <h3 className='text-center no-data-text'>{this.props.emptyText ? this.props.emptyText : 'No data available'}</h3>
          </div>
        </div>
      )
    }

    return (
      <div {...Object.assign.apply(this, Object.keys(this.props).map(key => ['className', 'styleClass'].includes(key) ? { [key]: this.props[key] } : {}))} className={this.props.noClass ? '' : 'table-wrapper ' + (!this.props.notResponsive ? 'table-responsive' : '')}>
        <ReactTooltip effect='solid' place='top' type='dark' />
        {this.props.loading &&
          <div className='box-loading-overlay'>
            <div>
              <i className='fa fa-circle-o-notch fa-spin' />
              <h3 className='text-center no-data-text'>Loading</h3>
            </div>
          </div>
        }
        <table className={'table ' + this.props.className} id='sortable-table' >
          <thead>
            {this.props.children}
          </thead>
          <tbody>
            {this.state.output && this.state.output.map((row, i) => {
              var isClickable = (typeof row[0] === 'object' && row[0].hasOwnProperty('onClick'))
              return (
                <tr key={this.state.tableUUID + i} className={(isClickable ? 'clickable' : '')} onClick={e => (isClickable ? (!this.selectedText() && row[0].onClick(e)) : null)}>
                  {row.map((column, x) => {
                    if (typeof column === 'object' && column && column.hasOwnProperty('onClick')) return null
                    if (typeof column === 'object' && column && column.hasOwnProperty('style')) {
                      return (
                        <td style={column.style} key={i + this.state.tableUUID + x}>
                          {column.content}
                        </td>
                      )
                    }
                    if (typeof column === 'object' && column && column.hasOwnProperty('className')) {
                      return (
                        <td className={column.className} key={i + this.state.tableUUID + x}>
                          {column.content}
                        </td>
                      )
                    }
                    return (
                      <td key={i + this.state.tableUUID + x}>
                        {column}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
        {!this.props.data.length && !this.props.loading &&
          <div className='clearfix'>
            <div className='col-md-12'>
              <div className='no-data-in-table-wrapper'>
                <div className='no-data-text-wrapper'>
                  <i className={'fa ' + (this.props.emptyIcon ? this.props.emptyIcon : 'fa-database')} />
                  <h3 className='text-center no-data-text'>{this.props.emptyText ? this.props.emptyText : 'No data available'}</h3>
                </div>
              </div>
            </div>
          </div>}
        {!!this.props.totalResults && (this.props.totalResults > this.props.count) &&
        <div>
          <Pagination
            activePage={this.props.activePage}
            itemsCountPerPage={this.props.count}
            totalItemsCount={this.props.totalResults}
            pageRangeDisplayed={5}
            onChange={e => {
              this.props.onPageChange(e)
            }}
          />
        </div>}
        {this.props.paginatable && (this.state.length > this.state.items) &&
          <div className='clearfix'>
            <div className='col-md-12'>
              <div className='flowtable-pagination-wrapper'>
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.items}
                  totalItemsCount={this.state.length}
                  pageRangeDisplayed={5}
                  onChange={e => this.handlePageChange(e)}
                />
                <Select
                  className='flowtable-pagination-select'
                  searchable={false}
                  labelKey='value'
                  valueKey='value'
                  clearable={false}
                  value={this.state.items}
                  options={[{ value: 5 }, { value: 10 }, { value: 20 }, { value: 30 }, { value: 50 }, { value: 100 }]}
                  onChange={(num) => this.handleCount(num.value)} />
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}
export default FlowTable



// WEBPACK FOOTER //
// ./src/components/basic/tables/FlowTable.js